<template>
  <div>
    <page-table />
  </div>
</template>
<script>
import PageTable from "./components/table"
export default {
  name: "purchase-pendingPlanFabric",
  components: {
    PageTable,
  },
}
</script>
